module.exports = __webpack_public_path__ + "static/media/28.b6a5155e.jpg";